import { addCollection } from "@iconify/react";

import { collections } from "./collections.gen";

// @iconify/react only reaches out to api.iconify.design for a name it has not
// been given, so registering the baked sets is all it takes for the existing
// <Icon icon="tabler:x" /> call sites to resolve locally. Imported for this
// side effect from src/index.js before the first render -- an icon rendered
// ahead of registration would start a network request that never completes on
// an isolated network.
collections.forEach(addCollection);

export { Icon } from "@iconify/react";
